// invoiceFields.ts
// Row config for the Generate Invoice UI.
// Each row can be a plain description row, or a "date" row (Final Invoice).

export interface InvoiceOptionRowConfig {
  value: "NEXT_INVOICE" | "UP_TO_DATE" | "FINAL_INVOICE";
  label: string;
  type: "text" | "date";
  description?: string; // shown when type === "text"
}

export const INVOICE_OPTION_ROWS: InvoiceOptionRowConfig[] = [
  {
    value: "NEXT_INVOICE",
    label: "Next Invoice",
    type: "text",
    description: "Process next scheduled period",
  },
  {
    value: "UP_TO_DATE",
    label: "Up To date",
    type: "text",
    description: "Process all unbilled periods to date",
  },
  {
    value: "FINAL_INVOICE",
    label: "Final Invoice",
    type: "date",
  },
];

export interface InvoiceGenerateFormData {
  option: "NEXT_INVOICE" | "UP_TO_DATE" | "FINAL_INVOICE";
  terminationDate: string;
}

export const initialInvoiceFormData: InvoiceGenerateFormData = {
  option: "NEXT_INVOICE",
  terminationDate: "",
};